import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { endOfISOWeek, isAfter, isBefore, isSameDay, isWithinInterval, startOfISOWeek } from "@vattenfall/util";

import { CalendarDirective, DateRange } from "../calendar.directive";

@Component({
  selector: "ui-week",
  templateUrl: "./week.component.html",
  styles: ["table {width: 100%; border-collapse: colapse;}"],
})
export class WeekComponent extends CalendarDirective {
  @Input() week!: Date[];

  @Output() readonly selectedWeekEvent: EventEmitter<DateRange> = new EventEmitter<DateRange>();
  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }
  /**
   * Selects the week the day belongs to.
   * @param day - select the week by day
   */
  public select(day: Date) {
    const start = startOfISOWeek(day);
    const end = endOfISOWeek(day);
    const selected = new DateRange(start, end);
    this.selectedWeekEvent.emit(selected);
  }
  /**
   * Checks if the given day is within the selected week
   * @param day - day to check
   * @returns - boolean value if the day is within the selected week
   */
  isSelectedWeek(day: Date) {
    if (!this.selected) return false;
    const weekRange = new DateRange(startOfISOWeek(day), endOfISOWeek(day));
    return isSameDay(weekRange.start, this.selected.start) && isSameDay(weekRange.end, this.selected.end);
  }

  /**
   * This function checks if a given date should be disabled.
   * It is disabled if the date is outside the min/max range or within the disabledDateRanges.
   * @param date - The date to check for being outside the min/max scope or within disabledDateRanges.
   * @returns a boolean value.
   */
  isDisabled(date: Date): boolean {
    const endOfWeeKDate = endOfISOWeek(date);
    const isOutsideMinAndMaxRange = !isWithinInterval(endOfWeeKDate, { start: this.min, end: this.max });
    const isWithinDisabledRanges = this.disabledDateRanges.some(
      (range: DateRange) => isBefore(range.start, startOfISOWeek(date)) && isAfter(range.end, endOfWeeKDate)
    );

    return isWithinDisabledRanges || isOutsideMinAndMaxRange;
  }
}
